import { Box, Circle, Cone, Cylinder, PersonStanding, type LucideIcon } from "lucide-react"
import type { SceneCharacterFigure } from "@/lib/location-scene-3d/character-figure"

export type CharacterFigureCatalogItem = {
  id: SceneCharacterFigure
  icon?: LucideIcon
  /** Digit in the icon slot. Quadruped is 4, biped is 2. */
  mark?: string
}

/** Picker order: creatures, then the primitive shapes already in the scene. */
export const CHARACTER_FIGURES: CharacterFigureCatalogItem[] = [
  { id: "humanoid", icon: PersonStanding },
  { id: "quadruped", mark: "4" },
  { id: "biped", mark: "2" },
  { id: "box", icon: Box },
  { id: "sphere", icon: Circle },
  { id: "cylinder", icon: Cylinder },
  { id: "cone", icon: Cone },
]

type MissingFigure = Exclude<SceneCharacterFigure, (typeof CHARACTER_FIGURES)[number]["id"]>
const _allFiguresListed: MissingFigure extends never ? true : MissingFigure = true
void _allFiguresListed
